import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

import availabilityMatches from './availabilityMatchesReducer'
import availabilityRequests from './availabilityRequestsReducer'
import facilities from './facilitiesReducer'
import agency from './agencyReducer'
import notifications from './notificationsReducer'

import groupedAvailabilities from './groupedAvailabilitiesReducer'

import requestForm from './requestFormReducer'
import flash from './flashReducer'
import session from './sessionReducer'
import user from './userReducer'
import calendar from './calendarReducer'
import admin from './adminReducer'

export default history =>
  combineReducers({
    router: connectRouter(history),
    availabilityMatches,
    availabilityRequests,
    facilities,
    agency,
    flash,
    groupedAvailabilities,
    requestForm,
    session,
    user,
    notifications,
    calendar,
    admin
  })
